var HashSet = require("../../collections/hashSet.js");

var TreeEvent = function(type, col, key, val, old){
    this.type = type;
    this.target = {
        node: col._treeNode,
        collection: col,
        key: key
    };
    this.value = val;
    this.oldValue = old;
    this.path = [];

    this.bubbles = false;   // indicates if this event is triggered
};

TreeEvent.prototype.trigger = function(){
    if (this.bubbles) return;
    else this.bubbles = true;

    var event = this;
    var triggeredHandlers = new HashSet();

    function runBubbleHandlers(target){
        event.path.unshift(target);

        // run bubble handlers for collection (if not already done)
        if (triggeredHandlers.contains(target.collection)) return event.path.shift();
        target.collection.handlers.bubble && target.collection.handlers.bubble.forEach(function(k, handler){
            handler.call(target.collection, event);
        });
        triggeredHandlers.add(target.collection);

        // run bubble handlers for node (if not already done)
        if (triggeredHandlers.contains(target.node)) return event.path.shift();
        target.node.handlers.bubble && target.node.handlers.bubble.forEach(function(k, handler){
            handler.call(target.node, event);
        });
        triggeredHandlers.add(target.node);

        // first event bubbles up to parent
        if (target.node.parentCollection){  //
            var parentTarget = {
                node: target.node.parent(),
                collection: target.node.parentCollection[0],
                key: target.node.parentCollection[1]
            };
            runBubbleHandlers(parentTarget);
        }

        // next event bubbles to referrers
        target.node.referrers.forEach(function(referrer){
            var refTarget = {
                node: referrer[0]._treeNode,
                collection: referrer[0],
                key: referrer[1]
            };
            runBubbleHandlers(refTarget);
        });
        
        // at last event bubbles to the connected shadows
        target.node._triggeredShadows && target.node._triggeredShadows.forEach(function(shadow){
            var shadowTarget = {
                node: shadow._treeNode,
                collection:shadow,
                key: undefined
            };
            runBubbleHandlers(shadowTarget);
        });
        delete target.node._triggeredShadows;

        return event.path.shift();
    }
    runBubbleHandlers(this.target);

    this.bubbles = false;
};

// make the opposite change of this event (which will produce a new TreeEvent)
TreeEvent.prototype.revert = function(){
    switch (this.type){
        case "change":
            this.target.collection(this.oldValue);
            break;
        case "add":
            this.target.collection.remove(this.target.key);
            break;
        case "put":
            if (this.oldValue === undefined) this.target.collection.remove(this.target.key);
            else this.target.collection.put(this.target.key, this.oldValue);
            break;
        case "remove":
            var type = this.target.collection.getType();
            if (type == "map")  this.target.collection.put(this.target.key, this.oldValue);
            else this.target.collection.add(this.target.key, this.oldValue);
            break;
    }
};

// apply the changes of this event again (which will produce a new TreeEvent)
TreeEvent.prototype.reApply = function(){
    switch (this.type){
        case "change":
            this.target.collection(this.value);
            break;
        case "add":
            this.target.collection.add(this.target.key, this.value);
            break;
        case "put":
            this.target.collection.put(this.target.key, this.value);
            break;
        case "remove":
            this.target.collection.remove(this.target.key);
            break;
    }
};

module.exports = TreeEvent;